module.exports = __webpack_public_path__ + "img/lg_lliege.e5b2f193.png";